import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';

@Pipe({
	name: 'formatDate',
	standalone: false
})
export class FormatDatePipe implements PipeTransform {

	public transform (date, format: string = 'MMM D, YYYY'): string {
		return dayjs(date).format(format);
	}

}
